import * as React from "react"

const Sortation = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 160.18 160.12"
    {...props}
  >
    <title>{"SORTATION-1"}</title>
    <path
      fill="#4ead90"
      d="M61.99 109.02h10.19v10.19H61.99zM74.9 109.02h10.19v10.19H74.9zM87.81 109.02H98v10.19H87.81z"
    />
    <circle cx={63.52} cy={127.15} r={2.6} fill="#4ead90" />
    <path
      d="M74.54 124.55a2.6 2.6 0 1 0 2.6 2.6 2.62 2.62 0 0 0-2.6-2.6ZM85.57 124.55a2.6 2.6 0 1 0 2.6 2.6 2.59 2.59 0 0 0-2.6-2.6Z"
      fill="#4ead90"
    />
    <path
      d="M96.59 121.6H63.52a5.56 5.56 0 1 0-.47 11.11h33.54a5.56 5.56 0 0 0 .47-11.11Zm0 9.3H63.52a3.75 3.75 0 1 1-.39-7.49h33.46a3.75 3.75 0 0 1 .38 7.49Z"
      fill="#4ead90"
    />
    <circle cx={96.59} cy={127.15} r={2.6} fill="#4ead90" />
    <path
      d="M61.1 69.38v-8.31c3.42-2.85 7.13-6 10.9-9.48 5.36-4.9 7.3-7.32 7.3-11.6 0-5-3.65-6.26-8.18-6.26a54.4 54.4 0 0 0-9 .93v-7.93a85.79 85.79 0 0 1 9.48-.68c4.24 0 9.25.37 12.9 3.16 2.87 2.23 4.17 5.79 4.17 9.85 0 6.33-2.36 9.92-7 14.33-2.7 2.54-6.25 5.61-8.84 7.87v.25h16.49v7.87ZM95.5 69.38v-10h9.47v10Z"
      fill="#b9d816"
    />
    <path
      d="M143.32 111.87A70.82 70.82 0 0 0 84.1 9.29V0a80.08 80.08 0 0 1 67.26 116.52Z"
      fill="#3e4c5e"
    />
    <path
      d="M76.05 9.29a70.79 70.79 0 0 0-59.21 102.58l-8 4.65A80.07 80.07 0 0 1 76.05 0Z"
      fill="#bde3dc"
    />
    <path
      d="M20.87 118.83a70.77 70.77 0 0 0 118.41 0l8.05 4.65a80.06 80.06 0 0 1-134.51 0Z"
      fill="#3e4c5e"
    />
    <path
      d="M35.73 92a6.76 6.76 0 0 1-3.59.7 34 34 0 0 1-3.63-.2v-2.38a29.23 29.23 0 0 0 3.24.23 6.78 6.78 0 0 0 1.85-.2 1.15 1.15 0 0 0 .81-1.15c0-.68-.34-1-1.08-1.26-.52-.18-1.19-.34-1.8-.52-2-.52-3.06-1.48-3.06-3.51a3.53 3.53 0 0 1 1.5-3.15 6.25 6.25 0 0 1 3.42-.69 28 28 0 0 1 3.3.22v2.29c-1-.11-2.14-.22-3-.22a4.81 4.81 0 0 0-1.6.18 1.07 1.07 0 0 0-.74 1.1 1.15 1.15 0 0 0 1 1.19c.5.14 1.08.27 1.68.43 2.19.48 3.27 1.51 3.27 3.71A3.6 3.6 0 0 1 35.73 92ZM49.59 81.17a6.58 6.58 0 0 1 1.83 5.09c0 2.15-.52 4.06-1.82 5.15a6.53 6.53 0 0 1-4.39 1.3 6.3 6.3 0 0 1-4.37-1.3 6.54 6.54 0 0 1-1.87-5.11c0-2.11.52-4 1.82-5.13a6.53 6.53 0 0 1 4.39-1.3 6.44 6.44 0 0 1 4.41 1.3Zm-1.1 5.2c0-2.73-1-4.16-3.28-4.16s-3.24 1.26-3.24 4 1 4.16 3.29 4.16 3.23-1.26 3.23-4ZM60.91 92.46l-2.49-4.32h-1.51v4.32h-2.88V80.12h4.61c1.73 0 3.1.18 4.07 1a4.51 4.51 0 0 1-.09 6 3.18 3.18 0 0 1-1.19.63l2.81 4.72Zm-2.42-10.12h-1.58V86h1.6c1.66 0 2.34-.56 2.34-1.84s-.88-1.82-2.36-1.82ZM69.53 92.46v-10h-4v-2.34h10.88v2.31h-4v10ZM86.45 92.46l-.88-2.61h-4.7l-.9 2.61h-3l4.48-12.34h3.62l4.48 12.34Zm-3.21-9.71-1.67 4.86h3.29ZM94.15 92.46v-10h-4v-2.34h10.82v2.31h-4v10ZM103.22 92.46V80.12h2.88v12.34ZM119.32 81.17a6.58 6.58 0 0 1 1.83 5.09c0 2.15-.52 4.06-1.81 5.15a6.54 6.54 0 0 1-4.4 1.3 6.3 6.3 0 0 1-4.37-1.3 6.54 6.54 0 0 1-1.86-5.11c0-2.11.52-4 1.82-5.13a8.09 8.09 0 0 1 8.79 0Zm-1.1 5.2c0-2.73-1-4.16-3.28-4.16s-3.29 1.26-3.29 4 1 4.16 3.29 4.16 3.28-1.26 3.28-4ZM131.2 92.46l-4.76-8v8h-2.65V80.12h3.35l4.52 7.88h.06v-7.88h2.63v12.34Z"
      fill="#181c25"
    />
  </svg>
)

export default Sortation
